import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ChartHelper } from "../result/chart.helper";
import chroma from "chroma-js";

let ColorPalettePickerComponent = {
    selector: "vcColorPalettePicker",
    templateUrl:
        "/angular/components/chart/color-palette-picker.component.html",
    bindings: {},
    controller: class ColorPalettePickerController {
        public dialog: DialogUtils;
        public chartHelper: ChartHelper;
        public selectedPalette: any;

        constructor(
            $scope: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            ChartHelper: ChartHelper
        ) {
            this.dialog = DialogUtils;
            this.chartHelper = ChartHelper;
        }

        cancel() {
            this.dialog.cancel();
        }
        save() {
            this.dialog.hide(this.selectedPalette);
        }

        selectPalette(palette: any) {
            this.selectedPalette = palette;
        }

        generateColors(palette: any) {
            return chroma.scale(palette.colors).mode("lch").colors(5);
        }
    },
};

angular
    .module("chart", [])
    .component(
        ColorPalettePickerComponent.selector,
        ColorPalettePickerComponent
    );
